import React, { useState, useEffect } from "react";
import "./nav.scss";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Collapse,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { getNavigationTabs } from "./config";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation } from "react-router-dom";

const Navbar = ({
  logoutHandler,
  navigate,
  anchorElUser,
  setAnchorElUser,
  logo,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState({});
  const [tabsList, setTabsList] = useState([]);
  const { pathname } = useLocation();
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuClick = (label) => {
    setOpenMenu((prevOpenMenu) => ({
      ...prevOpenMenu,
      [label]: !prevOpenMenu[label],
    }));
  };

  const renderSubMenu = (submenu) => (
    <List component="div" disablePadding>
      {submenu.map((subItem, index) => (
        <div
          className={pathname === subItem.url && "active-list"}
          onClick={() => redirectToRoute(subItem.url)}
          style={subItem?.disabled && { display: "none" }}
          key={index}
        >
          <ListItem key={subItem.name} sx={{ padding: 0.5, pl: 5, pr: 1.5 }}>
            <ListItemText primary={subItem.name} />
          </ListItem>
        </div>
      ))}
    </List>
  );
  const redirectToRoute = (url) => {
    navigate(url);
    setDrawerOpen(false);
  };
  useEffect(() => {
    const tabs = getNavigationTabs();
    setTabsList(tabs);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "2px 1rem",
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>
        <div className="logo-bg">
          <img src={logo} alt="LOGO" height="30px" width="50px" />
        </div>

        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <div>
            <AccountCircleIcon
              onClick={(event) => setAnchorElUser(event.currentTarget)}
              sx={{ cursor: "pointer" }}
              color="primary"
            />
            <Menu
              id="basic-menu"
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={() => setAnchorElUser(null)}
              sx={{ mt: 1 }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => {
                  logoutHandler();
                  setAnchorElUser(null);
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Box>
      </Box>
      <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: 2,
          }}
        >
          <img src={logo} alt="LOGO" width="50px" />
          <IconButton onClick={handleDrawerToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {tabsList.map((item) => (
            <div
              key={item.name}
              className={pathname === item?.url && "active-list"}
              onClick={
                item.children
                  ? () => handleMenuClick(item.name)
                  : () => redirectToRoute(item?.url)
              }
            >
              <ListItem href={item.url} sx={{ padding: 0.5, pl: 1.5, pr: 1.5 }}>
                {/* {item.icon && item.icon} */}
                <ListItemText primary={item.name} />
                {item.children && (
                  <IconButton edge="end">
                    {openMenu[item.name] ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                )}
              </ListItem>
              {item.children && (
                <Collapse in={openMenu[item.name]}>
                  {renderSubMenu(item.children)}
                </Collapse>
              )}
            </div>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
